import { Component, OnInit, ChangeDetectionStrategy, ViewChild, TemplateRef } from '@angular/core';

import { MinhaAgenda } from '@app/models/minha-agenda';
import { MinhaAgendaService } from '@app/services/minha-agenda.service';
import { CalendarEvent, CalendarEventTimesChangedEvent, CalendarView } from 'angular-calendar';
import {
  isSameMonth,
  isSameDay,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  startOfDay,
  endOfDay,
  format
} from 'date-fns';
import { colors } from '@app/utils/colors';
import { Subject } from 'rxjs';
import { ParticipanteService } from '@app/services/participante.service';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-minha-agenda-lista',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './minha-agenda-lista.component.html'
})
export class MinhaAgendaListaComponent implements OnInit {
  lstMinhaAgenda: MinhaAgenda[];
  events: CalendarEvent[] = [];
  dataHoje = new Date();
  filtro = 'Mês';
  transferirMeAvise = false;
  refresh: Subject<any> = new Subject();
  constructor(private minhaAgendaService: MinhaAgendaService,
    private participanteService: ParticipanteService,
    private _modalService: BsModalService) {

  }

  // calendario
  @ViewChild('modalContent', { static: true }) modalContent: TemplateRef<any>;

  view: 'day' | 'week' | 'month' | CalendarView = 'month';
  viewDate: Date = new Date();
  activeDayIsOpen = false;

  // activeDayIsOpen: boolean = false;


  modalData: {
    action: string;
    event: CalendarEvent;
  };

  dayClicked({ date, events }: { date: Date; events: CalendarEvent[] }): void {
    if (isSameMonth(date, this.viewDate)) {
      if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
        this.activeDayIsOpen = false;
      } else {
        this.activeDayIsOpen = true;
        this.viewDate = date;
      }
    }
  }

  eventTimesChanged({
    event,
    newStart,
    newEnd
  }: CalendarEventTimesChangedEvent): void {
    event.start = newStart;
    event.end = newEnd;
    this.handleEvent('Dropped or resized', event);
    this.refresh.next();
  }

  handleEvent(action: string, event: CalendarEvent): void {
    this.modalData = { event, action };
    this._modalService.show(this.modalContent);
  }

  ngOnInit() {
    this.obterPermissao();
    this.obterTodos('', '');
  }
  obterTodos(dataInicial: string, dataFinal: string) {
    this.activeDayIsOpen = false;
    this.minhaAgendaService.obterMinhaAgenda(this.view, dataInicial, dataFinal)
      .toPromise().then(data => {
        this.lstMinhaAgenda = data;
        this.events = [];
        for (let i = 0; i < this.lstMinhaAgenda.length; i++) {
          const minhaAgenda = this.lstMinhaAgenda[i];
          const horaInicio = minhaAgenda.HoraInicioAgendada.split(':');
          // let horaFim = minhaAgenda.HoraFim.split(":");
          const dataAgendada = minhaAgenda.DataAgendada.toString().split('T')[0].split('-');

          const dd = parseInt(dataAgendada[2], 10);
          const monthIndex = parseInt(dataAgendada[1], 10) - 1;
          const yyyy = parseInt(dataAgendada[0], 10);

          const audiencia = minhaAgenda.Audiencia ? ' (AUDIÊNCIA) ' : '';
          const atendimento = minhaAgenda.Atendimento ? ' (ATENDIMENTO) ' : '';
          const cancelado = minhaAgenda.Cancelado ? ' <strong style="color:red!important;">(CANCELADO)</strong>' : '';
          const realizado1 = minhaAgenda.Realizado ? '<strike>' : '';
          const realizado2 = minhaAgenda.Realizado ? '</strike>' : '';
          if (new Date(yyyy, monthIndex, dd).toDateString() === this.dataHoje.toDateString()) {
            this.activeDayIsOpen = true;
          }

          minhaAgenda.ClienteNome = minhaAgenda.Participante == null ? ' ' : '- ' + minhaAgenda.Participante.NomeFantasia;

          this.events.push({
            title: realizado1 + '<strong>' + minhaAgenda.HoraInicioAgendada + audiencia + atendimento + '</strong> ' + minhaAgenda.ClienteNome + ' - ' + minhaAgenda.Descricao + cancelado + realizado2,
            start: new Date(yyyy, monthIndex, dd, Number.parseInt(horaInicio[0], 10), Number.parseInt(horaInicio[1], 10), 0),
            end: new Date(yyyy, monthIndex, dd, Number.parseInt(horaInicio[0], 10), Number.parseInt(horaInicio[1], 10), 0),
            color: minhaAgenda.Cancelado ? colors.red : minhaAgenda.EmDestaque ? colors.yellow : colors.blue,
            draggable: false,
            resizable: {
              beforeStart: true,
              afterEnd: true
            },
            meta: {
              inicio: minhaAgenda.HoraInicioAgendada,
              tipo: minhaAgenda.Audiencia ? "Audiência" : minhaAgenda.Atendimento ? "Atendimento" : "",
              cliente:  minhaAgenda.ClienteNome || minhaAgenda.Participante.NomeFantasia || "",
              descricao: minhaAgenda.Descricao
            },
            actions: [{
              label: '<i class="fa fa-fw fa-pencil"></i>',
              onClick: ({ event }: { event: CalendarEvent }): void => {
                window.location.href = '#/agenda/minha-agenda/editar/' + minhaAgenda.Id;
              }
            }]
          });
        }
        this.refresh.next();
      });
  }

  deletar(id: number) {
    this.minhaAgendaService.deletar(id).subscribe((data) => {

      const getStart: any = {
        month: startOfMonth,
        week: startOfWeek,
        day: startOfDay
      }[this.view];

      const getEnd: any = {
        month: endOfMonth,
        week: endOfWeek,
        day: endOfDay
      }[this.view];

      const dataInicial = format(getStart(this.viewDate), 'dd/MM/yyyy');
      const dataFinal = format(getEnd(this.viewDate), 'dd/MM/yyyy');

      this.obterTodos(dataInicial, dataFinal);
    });
  }

  obterPermissao() {
    this.participanteService.verificaPermissaoUsuario(0, 'TransferirAgendaParaOutrosUsuarios')
      .subscribe(data => {
        this.transferirMeAvise = data;
        this.refresh.next();
      });
  }

  viewDateChange(type: 'day' | 'week' | 'month' | CalendarView) {

    if (type) {
      this.view = type;
    }

    const getStart: any = {
      month: startOfMonth,
      week: startOfWeek,
      day: startOfDay
    }[this.view];

    const getEnd: any = {
      month: endOfMonth,
      week: endOfWeek,
      day: endOfDay
    }[this.view];


    const dataInicial = format(getStart(this.viewDate), 'dd/MM/yyyy');
    const dataFinal = format(getEnd(this.viewDate), 'dd/MM/yyyy');

    this.obterTodos(dataInicial, dataFinal);

  }
}
